export default "__VITE_PUBLIC_ASSET__817bf200__"